/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDataExportRequest
 */
export interface UserDataExportRequest {
    /**
     * 
     * @type {string}
     * @memberof UserDataExportRequest
     */
    recipientEmail: string;
}

/**
 * Check if a given object implements the UserDataExportRequest interface.
 */
export function instanceOfUserDataExportRequest(value: object): value is UserDataExportRequest {
    if (!('recipientEmail' in value) || value['recipientEmail'] === undefined) return false;
    return true;
}

export function UserDataExportRequestFromJSON(json: any): UserDataExportRequest {
    return UserDataExportRequestFromJSONTyped(json, false);
}

export function UserDataExportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDataExportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'recipientEmail': json['recipientEmail'],
    };
}

export function UserDataExportRequestToJSON(json: any): UserDataExportRequest {
    return UserDataExportRequestToJSONTyped(json, false);
}

export function UserDataExportRequestToJSONTyped(value?: UserDataExportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recipientEmail': value['recipientEmail'],
    };
}

